export const designWidth = 1920;
export const designHeight = 1080;
export const designWidthPx = `${designWidth}px`;
export const designHeightPx = `${designHeight}px`;
export const designRatio = designWidth / designHeight;
